import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EstablishmentService } from '../../../services/establishment.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MissionService } from '../../../services/mission.service';
import { error } from 'console';
import { FlagType } from '../../../shared/utils/enums';
import { FlagService } from '../../../shared/services/flag.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-form-annulation-contract',
  templateUrl: './form-annulation-contract.component.html',
  styleUrl: './form-annulation-contract.component.scss',
})
export class FormAnnulationContractComponent {
  etablissment: any;
  loading = false;
  emailBody = '';
  form: FormGroup = this.fb.group({
    emailBody: [
      this.data.textFormulaire
        ? ''
        : 'Bonjour, Je souhaite annuler ma candidature après avoir signé mon contrat',
      Validators.required,
    ],
    emailObject: [
      this.data.textFormulaire || 'Annuler une mission déjà signée',
    ],
  });
  constructor(
    public dialogRef: MatDialogRef<FormAnnulationContractComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private etablissmentApi: EstablishmentService,
    private missionApi: MissionService,
    private fb: FormBuilder,
    private flag: FlagService,
    private auth: AuthService
  ) {}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.emailBody = this.data?.textFormulaire;
    this.form.controls['emailObject'].disable();
    this.fetchEtablissment();
  }
  fetchEtablissment() {
    this.loading = true;
    this.etablissmentApi
      .getEstablishmentById(
        this.data.etablissementId || this.data.data.etablissementId
      )
      .subscribe({
        next: (res) => {
          this.etablissment = res;
          this.loading = false;
        },
        error: (err) => {
          console.log(err);
          this.loading = false;
        },
      });
  }
  submit() {
    if (this.data?.textFormulaire) {
      if (this.form.valid) {
        this.missionApi
          .contestRejection({
            ...this.form.value,
            candidateId: this.auth.user?.collary_id,
            missionId: this.data.data.id,
          })
          .subscribe({
            next: (res) => {
              this.flag.displayFlag(
                'Votre candidature a été annulée avec succès',
                FlagType.success
              );
              this.dialogRef.close();
            },
            error: (err) => {
              console.log(err);
              this.flag.displayFlag('Oops ! Error !', FlagType.error);
              this.dialogRef.close();
            },
          });
      }
    } else {
      if (this.form.valid) {
        this.missionApi
          .cancelMission({
            ...this.form.value,
            candidateId: this.data.candidatId,
            missionId: this.data.id,
          })
          .subscribe({
            next: (res) => {
              this.flag.displayFlag(
                'Votre candidature a été annulée avec succès',
                FlagType.success
              );
              this.dialogRef.close();
            },
            error: (err) => {
              console.log(err);
              this.flag.displayFlag('Oops ! Error !', FlagType.error);
              this.dialogRef.close();
            },
          });
      }
    }
  }
}
